var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3767 28.1357L16.2441 28.3674H16.5108L16.3767 28.1357Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6228 28.1357L26.0618 22.1787L22.939 16.771L19.5 22.728L22.6228 28.1357Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4885 28.3669L22.6225 28.1352L19.4997 22.7275L16.377 28.1352L16.511 28.3669H22.4885Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0623 22.1787L29.6353 28.3674H22.7559L25.8786 33.7751H32.7581L26.0623 22.1772V22.1787Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5003 0L12.9385 11.3633L0 33.775H6.2412H13.1221L16.2449 28.3674H9.36544L12.9385 22.1786L16.0613 16.7709L19.5003 10.8139L22.9393 16.7709L26.0621 11.3633L19.5003 0Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5105 28.3677H16.2439L13.1211 33.7754H19.3652L19.4993 33.5437L16.5105 28.3677Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0622 22.1786V22.1772L32.7581 33.7751H39.0007L26.0622 11.3633L22.9395 16.771L26.0622 22.1786Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5004 33.5437L22.4892 28.3677H16.5117L19.5004 33.5437Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.826e5156c1d9a50c83c9e2ce210a4b4b.svg";
export { ForwardRef as ReactComponent };